import nanoajax from "nanoajax";
import Swiper from "swiper";
import slugify from "slugify";
import PubSub from "pubsub-js";
import { getItemsOnBlog } from "../../../shared/utils";
import { stretchFrom } from "../../../searchform";
import "../../../shared/pubsub-triggers";

export const createComponentsCia = () => {
	const limitPostsBlog = 4;

	if (document.body.className.match(`.cia-aerea`)) {
		const nameCia = document.querySelector("#nameCia").innerHTML;
		const blogDestinosContent = document.querySelector(
			".blog-feriado .swiper-container .swiper-wrapper"
		);
		const couponCopy = document.querySelector(".couponsearch--boxes-codes");
		const coupon = document.querySelector(".couponsearch--boxes-codes .code");
		const couponMessage = document.querySelector(".couponsearch--boxes-codes span:not(.code)");
		let sizeBlog = 0;

		if (couponCopy) {
			couponCopy.addEventListener("click", () => {
				var textarea = document.createElement("textarea");
				textarea.id = "temp_element";
				textarea.style.height = 0;
				document.body.appendChild(textarea);
				textarea.value = coupon.innerText;
				var selector = document.querySelector("#temp_element");
				selector.select();
				document.execCommand("copy");
				document.body.removeChild(textarea);
				couponMessage.innerHTML = "Copiado com sucesso";
				couponMessage.style.color = "#F9BE3F";
			});
		}

		window.addEventListener("load", function() {
			PubSub.publish("dataLayer", {
				event: "ditoTrack",
				ditoTrack: {
					action: "acessou-companhia",
					data: {
						cidade_destino: nameCia
					}
				}
			});
		});

		const nearbyResponseElement = document.querySelector("#nearbyResponse");

		if (nearbyResponseElement && JSON.parse(nearbyResponseElement.innerHTML).length) {
			const airportData = JSON.parse(nearbyResponseElement.innerHTML);
			const groupIATA = airportData.filter(airport => airport.group);
			if (groupIATA.length > 0) {
				stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
					city: groupIATA[0].city,
					iata: groupIATA[0].group,
					name: "Todos",
					country: groupIATA[0].country == "Brazil" ? "BR" : "" //TODO - retornar países com abreviação de dois caracteres do banco
				});
			} else {
				stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
					city: airportData[0].city,
					iata: airportData[0].iata,
					name: airportData[0].name,
					country: airportData[0].country == "Brazil" ? "BR" : ""
				});
			}
		}

		nanoajax.ajax(
			{
				url: `https://www.maxmilhas.com.br/blog/?feed=rss2&s=${slugify(nameCia)}`,
				method: "GET"
			},
			function(code, responseText, request) {
				let data;

				document.querySelector(".blog-feriado .loading").remove();

				if (code === 200 && responseText) {
					if (window.DOMParser) {
						const parser = new DOMParser();
						data = parser.parseFromString(responseText, "text/xml");
					} else {
						// Internet Explorer
						data = new ActiveXObject("Microsoft.XMLDOM");
						data.async = false;
						data.loadXML(responseText);
					}

					const channelXML = data.getElementsByTagName("channel")[0];

					const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

					const createItemsOnScreen = (channelXML, length) => {
						sizeBlog = length;

						for (var i = 0; i < limitPostsBlog; i++) {
							const item = channelXML.getElementsByTagName("item")[i];

							if (!item) {
								var swiperBlogFriday = new Swiper(".blog-feriado .swiper-container", {
									pagination: {
										el: null,
										clickable: true
									},
									simulateTouch: false,
									loop: false,
									slidesPerView: sizeBlog,
									slidesPerGroup: sizeBlog,
									slidesPerColumn: 1,
									spaceBetween: 30,
									nextButton: ".blog-feriado .swiper-button-next",
									prevButton: ".blog-feriado .swiper-button-prev",
									breakpoints: {
										768: {
											pagination: {
												el: ".blog-feriado .swiper-pagination"
											},
											simulateTouch: true,
											slidesPerView: 1,
											slidesPerGroup: 1,
											slidesPerColumn: 1,
											loop: true
										}
									}
								});

								return false;
							}

							const title = item.getElementsByTagName("title")[0].textContent;
							const link = item.getElementsByTagName("link")[0].textContent;
							const image = item.getElementsByTagName("image")[0]
								? item.getElementsByTagName("image")[0].textContent
								: "<img width='355' height='237' src='../../../../img/defaults/img-default-770x305.jpg' class='attachment-image-372 size-image-372 wp-post-image' />";
							const description = item.getElementsByTagName("description")[0].textContent;

							let columns = "";

							if (length == 3) {
								columns = " col-md-4";
							} else if (length == 2 && i == 0) {
								columns = " col-md-4 col-md-offset-2";
							} else if (length == 2 && i != 0) {
								columns = " col-md-4";
							} else {
								columns = " col-md-3";
							}

							blogDestinosContent.innerHTML += `<div class="swiper-slide">
																		<a href="${link.replace(/https:\/\/maxmilhas\.wpengine\.com/, 'https://www.maxmilhas.com.br/blog')}" class="card-largetitle blog" target="_blank">
																				<div class="card-largetitle-item">
																						<div class="card-largetitle-item--title">
																								${image}
																						</div>
																						<div class="card-largetitle-item--info">
																								<div class="card-largetitle-item--info-infos">
																										<h4>${title}</h4>
																										<p class="card-largetitle-item--info-text">
																										${description}</p>
																								</div>
																						</div>
																				</div>
																		</a>
																</div>`;
						}

						sizeBlog = sizeBlog > 4 ? (sizeBlog = 4) : (sizeBlog = sizeBlog);

						var swiperBlogFriday = new Swiper(".blog-feriado .swiper-container", {
							pagination: {
								el: null,
								clickable: true
							},
							navigation: {
								nextEl: ".blog-feriado .swiper-button-next",
								prevEl: ".blog-feriado .swiper-button-prev",
							},
							simulateTouch: false,
							loop: false,
							slidesPerView: sizeBlog,
							slidesPerGroup: sizeBlog,
							slidesPerColumn: 1,
							spaceBetween: 30,
							breakpoints: {
								768: {
									pagination: {
										el: ".blog-feriado .swiper-pagination",
									},
									simulateTouch: true,
									slidesPerView: 1,
									slidesPerGroup: 1,
									slidesPerColumn: 1,
									loop: true
								}
							}
						});
					};

					if (length < 2) {
						nanoajax.ajax(
							{
								url: `https://www.maxmilhas.com.br/blog/?feed=rss2`,
								method: "GET"
							},
							function(code, responseText, request) {
								if (window.DOMParser) {
									const parser = new DOMParser();
									data = parser.parseFromString(responseText, "text/xml");
								} else {
									// Internet Explorer
									data = new ActiveXObject("Microsoft.XMLDOM");
									data.async = false;
									data.loadXML(responseText);
								}

								const channelXML = data.getElementsByTagName("channel")[0];

								const { length } = getItemsOnBlog(channelXML.getElementsByTagName("item"));

								createItemsOnScreen(channelXML, length);
							}
						);
					} else {
						createItemsOnScreen(channelXML, length);
					}
				} else {
					blogDestinosContent.innerHTML += `<div class="col-xs-16">
                    <a href="#" class="card-largetitle blog" target="_blank">
                        <div class="card-largetitle-item">
                            <div class="card-largetitle-item--title">
                                <img src="#" alt="">
                            </div>
                            <div class="card-largetitle-item--info">
                                <div class="card-largetitle-item--info-infos">
                                    <h4>Ops!</h4>
                                    <p class="card-largetitle-item--info-text">Ocorreu um erro, tente novamente.</p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>`;
				}
			}
		);
	}
};

var swiperMaisBuscadoos = new Swiper("#swiper-mais-buscados .swiper-container", {
	slidesPerView: 6,
	slidesPerGroup: 6,
	spaceBetween: 30,
	pagination: {
		el: ".swiper-pagination",
		clickable: true
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		1919: {
			slidesPerGroup: 4,
			slidesPerView: 4
		},
		1199: {
			slidesPerGroup: 3,
			slidesPerView: 3
		},
		991: {
			slidesPerGroup: 3,
			slidesPerView: 3
		},
		767: {
			slidesPerGroup: 1,
			slidesPerView: 1
		}
	}
});

var swiperDiscount = new Swiper("#swiper-discount-destiny .swiper-container", {
	pagination: {
		el: "#swiper-discount-destiny .swiper-pagination",
		clickable: true
	},
	simulateTouch: false,
	slidesPerView: 3,
	slidesPerGroup: 3,
	slidesPerColumn: 1,
	spaceBetween: 30,
	navigation: {
		nextEl: "#swiper-discount-destiny .swiper-button-next",
		prevEl: "#swiper-discount-destiny .swiper-button-prev",
	},
	breakpoints: {
		768: {
			simulateTouch: true,
			slidesPerView: 1,
			slidesPerGroup: 1,
			slidesPerColumn: 1
		}
	}
});

const ciasSliderNode = document.getElementById("cias-slider");

if (ciasSliderNode) {
	new Swiper(ciasSliderNode, {
		slidesPerView: 4,
		slidesPerGroup: 4,
		spaceBetween: 30,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true
		},
		breakpoints: {
			1919: {
				slidesPerGroup: 4,
				slidesPerView: 4
			},
			1199: {
				slidesPerGroup: 3,
				slidesPerView: 3
			},
			991: {
				slidesPerGroup: 3,
				slidesPerView: 3
			},
			767: {
				slidesPerGroup: 1,
				slidesPerView: 1
			}
		}
	});
}
